import { FileText, Search, Sparkles, TrendingUp, Users } from "lucide-react";
import { CardListSkeleton, SectionCard } from "@/shared/components";
import { useActivity } from "./hooks";

const ACTIVITY_ICONS: Record<string, React.ReactNode> = {
  search: <Search className="size-3.5 text-text-brand" />,
  fileText: <FileText className="size-3.5 text-amber-600" />,
  users: <Users className="size-3.5 text-violet-600" />,
  trendingUp: <TrendingUp className="size-3.5 text-emerald-600" />,
  sparkles: <Sparkles className="size-3.5 text-pink-600" />,
};

export function ActivityFeed() {
  const { data: activity, isLoading } = useActivity();

  return (
    <SectionCard title="최근 활동">
      {isLoading ? (
        <CardListSkeleton count={4} />
      ) : (
        <div className="space-y-3">
          {(activity ?? []).map((item) => (
            <div
              key={`${item.action}-${item.time}`}
              className="flex items-start gap-3 rounded-sm border border-stroke-subtle p-3"
            >
              {ACTIVITY_ICONS[item.iconKey] ?? (
                <Sparkles className="size-3.5 text-text-brand" />
              )}
              <div className="min-w-0">
                <p className="text-[12px] font-semibold text-text-brand">
                  {item.action}
                </p>
                <p className="text-[11px] text-text-tertiary">{item.detail}</p>
                <p className="mt-1 text-[10px] text-text-tertiary">
                  {item.time}
                </p>
              </div>
            </div>
          ))}
          {(!activity || activity.length === 0) && (
            <p className="py-6 text-center text-[12px] text-text-tertiary">
              최근 활동 내역이 없습니다.
            </p>
          )}
        </div>
      )}
    </SectionCard>
  );
}
